import axios from "axios";
import { gettoken } from "../../../../shared/services/token/token";
import apiurl from "../apiendpoint/apiendpoint";

export const apisaveCurrentaffairs = async (datas) => {
    try {
        const formData = new FormData();
        
        for (const key in datas) {
            if (key === 'pdfFiles') {
                datas[key].forEach((pdf, index) => {
                    if (pdf.file instanceof File) {
                        formData.append('pdfFiles', pdf.file);
                        formData.append(`pdfTitle_${index}`, pdf.title);
                    }
                });
            } else {
                formData.append(key, datas[key]);
            }
        }
        
        const token = gettoken();
        const res = await axios.post(`${apiurl()}/currentaffairs/apisavecurrentaffairs`, formData, { headers: { "Authorization": `Bearer ${token}`,"Content-Type": "multipart/form-data"}});

        return res.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
};

export const apigetallCurrentaffairs = async (params) => {
    try {
        const token = gettoken();
        const res = await axios.get(`${apiurl()}/currentaffairs/apigetallcurrentaffairs`,{params:params,headers: { "Authorization": `Bearer ${token}` }});
        return res.data;
    } catch (err) {
        console.log(err);
    }
};

export const apiupdateCurrentaffairs = async (_id, datas) => {
    try {
        const formData = new FormData();
        let hasNewFiles = false;
        
        for (const key in datas) {
            if (key === 'pdfFiles') {
                const newFiles = datas[key].filter(pdf => pdf.file instanceof File);
                
                if (newFiles.length > 0) {
                    hasNewFiles = true;
                    newFiles.forEach((pdf, index) => {
                        formData.append('pdfFiles', pdf.file);
                        formData.append(`pdfTitle_${index}`, pdf.title);
                    });
                } else {
                    formData.append('pdfFiles', JSON.stringify(datas[key]));
                }
            } else {
                formData.append(key, datas[key]);
            }
        }
        
        const token = gettoken();
        const res = await axios.put(`${apiurl()}/currentaffairs/apiupdatecurrentaffairs/${_id}`, formData, {headers: { "Authorization": `Bearer ${token}`,"Content-Type": "multipart/form-data"}});
        return res.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
};

export const apideleteCurrentaffairs = async (_id) => {
    try {
        const token = gettoken();
        const res = await axios.delete(`${apiurl()}/currentaffairs/apideletecurrentaffairs/${_id}`,{headers: { "Authorization": `Bearer ${token}` }});
        return res.data;
    } catch (err) {
        console.log(err);
    }
};

export const apigetCurrentAffairsHook = async (params) => {
    try {
        const token = gettoken();
        const res = await axios.get(`${apiurl()}/currentaffairs/apigetCurrentaffairsHooks`,{params:params,headers: { "Authorization": `Bearer ${token}` }});
        return res.data;
    } catch (err) {
        console.log(err);
    }
};